export enum FormType {
    GRAPH = "graph",
    REQUIREMENT = "requirement"
}